<div class="prs-site-footer" data-testing-id="prs-site-footer">
  <div class="container prs-site-footer__inner">
    <div class="prs-site-footer__columns">
      <nav
        class="prs-site-footer__col prs-site-footer__col--start"
        aria-labelledby="prs-footer-mypresidio-heading"
      >
        <h2 id="prs-footer-mypresidio-heading" class="prs-site-footer__heading">
          {{ 'footer.column.mypresidio' | translate }}
        </h2>
        <ul class="prs-site-footer__list">
          <li>
            <a class="prs-site-footer__link" routerLink="/help-center" data-testing-id="footer-help-center">
              {{ 'footer.link.help_center' | translate }}
            </a>
          </li>
          <li>
            <a class="prs-site-footer__link" routerLink="/contact-team" data-testing-id="footer-contact-team">
              {{ 'footer.link.contact_team' | translate }}
            </a>
          </li>
        </ul>
      </nav>

      <nav
        class="prs-site-footer__col prs-site-footer__col--end"
        aria-labelledby="prs-footer-trust-heading"
      >
        <h2 id="prs-footer-trust-heading" class="prs-site-footer__heading">
          {{ 'footer.column.trust_legal' | translate }}
        </h2>
        <ul class="prs-site-footer__list">
          <li>
            <a class="prs-site-footer__link" [href]="privacyHref" target="_blank" rel="noopener noreferrer">
              {{ 'footer.link.privacy' | translate }}
            </a>
          </li>
          <li>
            <a class="prs-site-footer__link" [href]="termsHref" target="_blank" rel="noopener noreferrer">
              {{ 'footer.link.terms' | translate }}
            </a>
          </li>
          <li>
            <a class="prs-site-footer__link" routerLink="/cookies">
              {{ 'footer.link.cookies' | translate }}
            </a>
          </li>
          <li>
            <a class="prs-site-footer__link" [href]="accessibilityHref" target="_blank" rel="noopener noreferrer">
              {{ 'footer.link.accessibility' | translate }}
            </a>
          </li>
        </ul>
      </nav>
    </div>

    <div class="prs-site-footer__bar">
      <p class="prs-site-footer__copy">
        {{ 'footer.copyright.presidio' | translate: { year: year } }}
      </p>
      <ul class="prs-site-footer__social" [attr.aria-label]="'footer.social.aria' | translate">
        @for (social of socialLinks; track social.href) {
          <li>
            <a
              class="prs-site-footer__social-link"
              [href]="social.href"
              target="_blank"
              rel="noopener noreferrer"
              [attr.aria-label]="social.labelKey | translate"
            >
              @switch (social.icon) {
                @case ('linkedin') {
                  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                    <path
                      fill="currentColor"
                      d="M20.45 20.45h-3.55v-5.57c0-1.33-.02-3.04-1.85-3.04-1.85 0-2.14 1.45-2.14 2.94v5.67H9.35V9h3.41v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.6 0 4.27 2.37 4.27 5.46v6.28zM5.34 7.43a2.06 2.06 0 1 1 0-4.12 2.06 2.06 0 0 1 0 4.12zM7.12 20.45H3.56V9h3.56v11.45zM22.23 0H1.77C.79 0 0 .77 0 1.73v20.54C0 23.23.79 24 1.77 24h20.45c.98 0 1.78-.77 1.78-1.73V1.73C24 .77 23.2 0 22.23 0z"
                    />
                  </svg>
                }
                @case ('facebook') {
                  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                    <path
                      fill="currentColor"
                      d="M22.68 0H1.32A1.32 1.32 0 0 0 0 1.32v21.36A1.32 1.32 0 0 0 1.32 24h11.5v-9.29H9.69v-3.62h3.13V8.41c0-3.1 1.89-4.79 4.66-4.79 1.32 0 2.46.1 2.79.14v3.24h-1.91c-1.5 0-1.79.71-1.79 1.76v2.31h3.58l-.47 3.62h-3.11V24h6.1A1.32 1.32 0 0 0 24 22.68V1.32A1.32 1.32 0 0 0 22.68 0z"
                    />
                  </svg>
                }
                @case ('x') {
                  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                    <path
                      fill="currentColor"
                      d="M18.9 1.15h3.37l-7.37 8.42L24 22.85h-7.41l-5.8-7.58-6.64 7.58H.76l7.88-9 8.26-12.7zm-1.18 19.5h1.87L6.4 3.07H4.4l13.32 17.58z"
                    />
                  </svg>
                }
                @case ('youtube') {
                  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                    <path
                      fill="currentColor"
                      d="M23.5 6.2a3.02 3.02 0 0 0-2.12-2.14C19.5 3.5 12 3.5 12 3.5s-7.5 0-9.38.56A3.02 3.02 0 0 0 .5 6.2 31.6 31.6 0 0 0 0 12a31.6 31.6 0 0 0 .5 5.8 3.02 3.02 0 0 0 2.12 2.14C4.5 20.5 12 20.5 12 20.5s7.5 0 9.38-.56a3.02 3.02 0 0 0 2.12-2.14A31.6 31.6 0 0 0 24 12a31.6 31.6 0 0 0-.5-5.8zM9.75 15.57V8.43L15.82 12l-6.07 3.57z"
                    />
                  </svg>
                }
                @case ('instagram') {
                  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                    <path
                      fill="currentColor"
                      d="M12 2.16c3.2 0 3.58.01 4.85.07 3.25.15 4.77 1.69 4.92 4.92.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.15 3.23-1.66 4.77-4.92 4.92-1.27.06-1.64.07-4.85.07s-3.58-.01-4.85-.07c-3.26-.15-4.77-1.7-4.92-4.92-.06-1.27-.07-1.64-.07-4.85s.01-3.58.07-4.85C2.38 3.92 3.9 2.38 7.15 2.23 8.42 2.17 8.8 2.16 12 2.16zm0-2.16C8.74 0 8.33.01 7.05.07 2.7.27.27 2.69.07 7.05.01 8.33 0 8.74 0 12s.01 3.67.07 4.95c.2 4.36 2.62 6.78 6.98 6.98C8.33 23.99 8.74 24 12 24s3.67-.01 4.95-.07c4.35-.2 6.78-2.62 6.98-6.98.06-1.28.07-1.69.07-4.95s-.01-3.67-.07-4.95C23.73 2.7 21.31.27 16.95.07 15.67.01 15.26 0 12 0zm0 5.84a6.16 6.16 0 1 0 0 12.32 6.16 6.16 0 0 0 0-12.32zM12 16a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm6.41-10.85a1.44 1.44 0 1 0 0 2.88 1.44 1.44 0 0 0 0-2.88z"
                    />
                  </svg>
                }
              }
            </a>
          </li>
        }
      </ul>
    </div>
  </div>
</div>
